import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, ComponentSync, LL_V_L, StorageKey } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import './Advisor_ErrorBoundary.scss';
import { ModuleFE_Advisor_EHREnvironment, ModuleFE_Advisor_Facility, ModuleFE_AdvisorSession, ModuleFE_EMInterface } from '@app/advisor-frontend';
import { _logger_logException } from '@nu-art/logger';
export class Advisor_ErrorBoundary extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.dir = nextProps.dir;
        state.panelKey = nextProps.panelKey;
        state.error = nextProps.error;
        return state;
    }
    async componentDidMount() {
        const dataVersion = new StorageKey('storage__artifact-version').get();
        const facilityId = ModuleFE_AdvisorSession.getCurrentFacilityId();
        const facility = ModuleFE_Advisor_Facility.cache.unique(facilityId);
        const environmentId = ModuleFE_AdvisorSession.getCurrentEHREnvironmentId();
        const environment = ModuleFE_Advisor_EHREnvironment.cache.unique(environmentId);
        const ticket = {
            dataVersion: dataVersion ?? 'N/A',
            type: 'bug',
            reportingUser: 'UI Automated System',
            actualBehaviorMessage: this.composeErrorMessage(),
            expectedBehaviorMessage: '',
            facilityName: facility?.name,
            environmentName: environment?.label,
        };
        const response = await ModuleFE_EMInterface.submitSupportTicket(ticket);
        if (response)
            this.logError('Failed to send auto-submitted bug-report', response);
    }
    composeErrorMessage() {
        let message = `Encountered unhandled error in panel with key ${this.state.panelKey}\n\n`;
        message += _logger_logException(this.state.error);
        return message;
    }
    render() {
        const className = _className('advisor-error-boundary', this.props.dir);
        return _jsxs(LL_V_L, { className: className, children: [_jsx(ICONS.advisor_v5_errorBoundary.component, {}), _jsxs(LL_V_L, { className: 'advisor-error-boundary__main', children: [_jsx("div", { className: 'advisor-error-boundary__title', children: "Something Went Wrong!" }), _jsx("div", { className: 'advisor-error-boundary__info', children: "The data you are looking for can't be found" }), _jsx(Button, { variant: 'primary', onClick: this.props.onClick, children: "Reload" })] })] });
    }
}
//# sourceMappingURL=Advisor_ErrorBoundary.js.map